import ErpCrud from "@/components/ErpCrud";

export default function AdminBookings() {
  return (
    <ErpCrud
      testid="admin-bookings"
      title="Advance Bookings"
      subtitle="Advance / pre-orders with token amount — app ke saath synced"
      endpoint="/admin/advance_bookings"
      fields={[
        { key: "customer_name", label: "Customer", type: "text" },
        { key: "customer_phone", label: "Phone", type: "text" },
        { key: "product_name", label: "Product", type: "text" },
        { key: "qty", label: "Qty", type: "number" },
        { key: "advance_amount", label: "Advance ₹", type: "number" },
        { key: "total_amount", label: "Total ₹", type: "number" },
        { key: "booking_date", label: "Booking Date", type: "date" },
        { key: "expected_date", label: "Expected Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: [
          { value: "booked", label: "Booked" }, { value: "ready", label: "Ready" },
          { value: "delivered", label: "Delivered" }, { value: "cancelled", label: "Cancelled" },
        ] },
        { key: "notes", label: "Notes", type: "textarea" },
      ]}
      columns={[
        { key: "customer_name", label: "Customer" },
        { key: "product_name", label: "Product" },
        { key: "qty", label: "Qty" },
        { key: "advance_amount", label: "Advance" },
        { key: "expected_date", label: "Expected" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
